export default {
  round: function (num, n = 2) {
    return (Math.round(num * Math.pow(10, n) + Number.EPSILON) / Math.pow(10, n)).toFixed(n)
  },
  roundNoZ: function (num, n = 2) {
    n = n === undefined ? 2 : n
    return (Math.round(num * Math.pow(10, n) + Number.EPSILON) / Math.pow(10, n))
  },
  countDecimals: function (num, precision) {
    if (!num) return 0
    if (typeof num === 'string') {
      if (num.indexOf('.') > 0) return num.split('.')[1].length
      else return 0
    }
    let parts = num.toFixed(precision).split('.')
    return parts.length > 1 ? parts[1].length : 0
  },
  formatNumberWithMultiplier: function (val, prec = -1, multiplier) {
    val = parseFloat(String(val).replace(/\s/g, ''))
    if (prec >= 0) {
      return this.formatNumber(val * multiplier, prec)
    }
    else {
      let formatted = this.formatNumber(val * multiplier, 10)
      while (formatted.endsWith('0') || formatted.endsWith('.')) {
        let stopAfter = formatted.endsWith('.')
        formatted = formatted.slice(0, -1)
        if (stopAfter) {
          break
        }
      }
      return formatted
    }
  },
  formatNumber: function (val, prec = 2, decsep = '.', thsep = '\u00a0', emptyIfZero = false) { // 0x00a0 = nbsp
    val = parseFloat(String(val).replace(/\s/g, ''))
    // val = this.round(val, prec)
    val = this.roundNoZ(val, prec)
    if (emptyIfZero && val === 0) return ''
    val = val.toFixed(prec)

    let pos
    if (prec) {
      pos = val.indexOf('.')
      val = val.substr(0, pos) + decsep + val.substr(pos + 1)
      pos -= 3
    }
    else {
      pos = val.length - 3
    }
    while (pos > 0) {
      val = val.substr(0, pos) + thsep + val.substr(pos)
      pos -= 3
    }
    return val
  },
  // formatAmount: function (value, trunc = true, precision = 0, emptyIfZero = false) {
  //   value = parseFloat(String(value).replace(/\s/g, ''))
  //   // let amt = this.round(value, precision)
  //   let amt = this.roundNoZ(value, precision)
  //   if (emptyIfZero && amt === 0) return ''
  //   amt = amt.toFixed(precision)

  //   let absamt = Math.abs(amt)
  //   if (absamt >= Math.pow(10, 9)) {
  //     amt = this.roundNoZ(amt / Math.pow(10, 9), trunc ? 0 : precision) + ' B'
  //   }
  //   else if (absamt >= Math.pow(10, 6)) {
  //     amt = this.roundNoZ(amt / Math.pow(10, 6), trunc ? 0 : precision) + ' M'
  //   }
  //   else if (absamt >= Math.pow(10, 3)) {
  //     amt = this.roundNoZ(amt / Math.pow(10, 3), trunc ? 0 : precision) + ' K'
  //   }
  //   else {
  //     amt = this.formatNumber(value, precision)
  //   }
  //   return amt
  // },
  formatAmount: function (value, precision = 0, precisionAbrev = null, emptyIfZero = false) {
    value = parseFloat(String(value).replace(/\s/g, ''))

    if (precisionAbrev === null) {
      precisionAbrev = precision
    }
    
    let amt = value
    if (Math.abs(amt) >= Math.pow(10, 9)) 
    {
      amt = this.roundNoZ(amt / Math.pow(10, 9), 9)
      if (emptyIfZero && amt === 0) return ''
      if (precisionAbrev) {
        amt = amt.toFixed(precisionAbrev) + ' B'
      } else {
        amt += ' B'
      }
    }
    else if (Math.abs(amt) >= Math.pow(10, 6)) {
      amt = this.roundNoZ(amt / Math.pow(10, 6), 6)
      if (emptyIfZero && amt === 0) return ''
      if (precisionAbrev) {
        amt = amt.toFixed(precisionAbrev) + ' M'
      } else {
        amt += ' M'
      }
    }
    else if (Math.abs(amt) >= Math.pow(10, 3)) {
      amt = this.roundNoZ(amt / Math.pow(10, 3), 3)
      if (emptyIfZero && amt === 0) return ''
      if (precisionAbrev) {
        amt = amt.toFixed(precisionAbrev) + ' k'
      } else {
        amt += ' k'
      }
    }
    else {
      if (precision) {
        amt = this.roundNoZ(value, precision)
      }
      if (emptyIfZero && amt === 0) return ''
      if (precision) {
        amt = this.formatNumber(value, precision)
      }
    }
    return amt
  },
  parseFloat: function (value, thsep = '\u00a0') {
    let unformat = value.split(thsep).join('')
    return parseFloat(unformat)
  }
  /*,
  formatNumber: function (val, prec, decsep, thsep) {
    prec = prec === undefined ? 2 : prec
    decsep = decsep || '.'
    thsep = thsep || '\u00a0' // 0x00a0 = nbsp
    val = this.round(val, prec)
    var pos
    if (prec) {
      pos = val.indexOf('.')
      val = val.substr(0, pos) + decsep + val.substr(pos + 1)
      pos -= 3
    }
    else {
      pos = val.length - 3
    }
    while (pos > 0) {
      val = val.substr(0, pos) + thsep + val.substr(pos)
      pos -= 3
    }
    return val
  }
  */

}
